import { forwardRef } from 'react';

export type SectionProps = React.ComponentPropsWithoutRef<'section'>;

const Section = forwardRef<HTMLElement, SectionProps>(function Section(
  { className, ...rest },
  ref,
) {
  return <section ref={ref} className={className} {...rest} />;
});

export default Section;
